import {Button, styled} from "@mui/material"
import React from "react"

const SegmentButtonStyled = styled(Button)(({theme}) => theme.SEGMENTBUTTON)
const SegmentButton = ({label, value, active, disabled, onClick}) => {
    return (
        <SegmentButtonStyled
            onClick={() => onClick(value)}
            disabled={disabled}
            className={active === value ? "active" : ""}
        >
            {label}
        </SegmentButtonStyled>
    )
}

export {SegmentButton}
